import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  search(searchObject) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}workOrderTask/search`, searchObject, AUTH_HEADERS())
  },
  get (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderTask/${id}`, AUTH_HEADERS())
  },
  create (task) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}workOrderTask`, task, AUTH_HEADERS())
  },
  update (id, task) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}workOrderTask/${id}`, task, AUTH_HEADERS())
  },
  removeCrew(crew) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}workOrderTask/removeCrew/?crewId=${crew.crewId}&taskId=${crew.taskId}`, AUTH_HEADERS())
  },
  addCrew(crew) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}workOrderTask/addCrew/?crewId=${crew.crewId}&taskId=${crew.taskId}`, crew, AUTH_HEADERS())
  },
  archive (id) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}workOrderTask/archive/${id}`, id, AUTH_HEADERS())
  },
  restore (id) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}workOrderTask/restore/${id}`, id, AUTH_HEADERS())
  },
  getISDList (match, limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderTask/getISDList?match=${match}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  getStartDateList (match, limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderTask/getStartDateList?match=${match}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  getLocationList (match, limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderTask/getLocationList?match=${match}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  getCPANumberList (match, limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderTask/getCPANumberList?match=${match}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  }
}
